import { AuthService } from './../service/common/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { MainPageService } from './main-page.service';
import { Router } from '@angular/router';
import { Component, OnInit, Input} from '@angular/core';
import { environment } from '../environments/environment';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { ShowViewerArgs } from '../models/viewer/ShowViewerArgs.model';

@Component({
  template: `<!-- <div>
    Welcome to DMT2 Web services.
</div>
<br>
<br>
<br> -->
<div *ngIf="isStpViewerVisible" id="viewerPanelTab" class="viewerPanel">
    <stp-configure #stpConfigure (onShowViewer)='showViewer($event)' [args]='showViewerArgs'></stp-configure>
</div>
<div class="row displayBlock" (click)="hide = true">
    <div class="col-sidebar">
        <app-side-menu [sideBar]="sideBar"></app-side-menu>
    </div>
    <div class="information flex" [ngClass]="{'hidden': hide}">
        <div class="col-md-2 information-arrow flex">
            <div class="information-arrow2"></div>
            <div class="information-square"></div>
        </div>
        <div class="col-md-7 information-text">Welcome to your Data Mainstance Tool. You can manage all data via this left navigation menu.</div>
        <div class="col-md-3 information-dismiss" (click)="hide = true">DISMISS</div>
    </div>
    <div class="col-navbar">
        <div class="navbar">
            <span>Home</span> 
            <i class="fa fa-angle-right" *ngIf="menuTitle"></i>
            <span>{{menuTitle | translate}}</span>
            <i class="fa fa-angle-right" *ngIf="chooseItem"></i>
            <span class="menuItem">{{chooseItem | translate}}</span>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'crossSections'">
            <div class="col-3">
                <app-cross-section-grid #sideBar [crossSectionComponent]="crossSectionComponent"></app-cross-section-grid>
            </div>
            <div class="col-9">
                <app-cross-section-managment (onShowViewer)='showViewer($event)' #crossSectionComponent></app-cross-section-managment>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'connectors'">
            <div class="col-3">
                <app-connector-grid #sideBar [connectorComponent]="connectorComponent"></app-connector-grid>
            </div>
            <div class="col-9">
                <app-connector-managment (onShowViewer)='showViewer($event)' #connectorComponent></app-connector-managment>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'bases'">
            <div class="col-3">
                <app-bases-grid #sideBar [basesComponent]="basesComponent"></app-bases-grid>
            </div>
            <div class="col-9">
                <app-bases-managment (onShowViewer)='showViewer($event)' #basesComponent></app-bases-managment>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'pipeFastenings'">
            <div class="col-3">
                <app-pipe-fastenings-grid #sideBar [pipeFasteningComponent]="pipeFasteningComponent"></app-pipe-fastenings-grid>
            </div>
            <div class="col-9">
                <app-pipe-fastenings-managment (onShowViewer)='showViewer($event)' #pipeFasteningComponent></app-pipe-fastenings-managment>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'accesories'">
            <div class="col-3">
                Accesories
            </div>
            <div class="col-9">

            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'pipeRings'">
            <div class="col-3">
                <app-pipe-rings-grid #sideBar [pipeRingsComponent]="pipeRingsComponent"></app-pipe-rings-grid>
            </div>
            <div class="col-9">
                <app-pipe-rings-managment (onShowViewer)='showViewer($event)' #pipeRingsComponent></app-pipe-rings-managment>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'channels'">
            <div class="col-3">
                <app-channels-grid #sideBar [channelComponent]="channelComponent"></app-channels-grid>
            </div>
            <div class="col-9">
                <app-channels-managment (onShowViewer)='showViewer($event)' #channelComponent></app-channels-managment>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'systems'">
            <div class="col-12">
                <app-systems-grid #sideBar></app-systems-grid>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'materials'">
            <div class="col-12">
                <app-materials-grid #sideBar></app-materials-grid>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'designBases'">
            <div class="col-12">
                <app-design-bases-grid #sideBar></app-design-bases-grid>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'interactionFormulas'">
            <div class="col-12">
                Interaction formulas
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'corosionProtection'">
            <div class="col-12">
                <app-corosion-protections-grid #sideBar></app-corosion-protections-grid>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'interactionEquations'">
            <div class="col-12">
                <app-interaction-equations-grid #sideBar></app-interaction-equations-grid>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'subcomponentsForVerification'">
            <div class="col-12">
                <app-subcomponents-verification-grid #sideBar></app-subcomponents-verification-grid>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'releases'">
            <div class="col-12">
                <app-releases-grid #sideBar></app-releases-grid>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'piperingGroups'">
            <div class="col-12">
                <app-pipering-groups-grid #sideBar></app-pipering-groups-grid>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'pipeFunctions'">
            <div class="col-12">
                <app-pipe-functions-grid #sideBar></app-pipe-functions-grid>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'pipeGroups'">
            <div class="col-12">
                <app-pipe-groups-grid #sideBar></app-pipe-groups-grid>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'pipeMaterialGroups'">
            <div class="col-12">
                <app-pipe-materials-grid #sideBar [managmentComponent]="pipeMaterialsManagment"></app-pipe-materials-grid>
                <app-pipe-material-managment #pipeMaterialsManagment ></app-pipe-material-managment>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'insulationMaterials'">
            <div class="col-12">
                <app-insulation-materials-grid #sideBar [managmentComponent]="insulationMaterialManagement"></app-insulation-materials-grid>
                <app-insulation-material-managment #insulationMaterialManagement ></app-insulation-material-managment>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'pipes'">
            <div class="col-12">
                <app-pipes-grid #sideBar [managmentComponent]="pipesManagment"></app-pipes-grid>
                <app-pipes-managment #pipesManagment ></app-pipes-managment>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'piperingBosses'">
            <div class="col-12">
                <app-pipering-bosses-grid #sideBar [managmentComponent]="piperingBossManagement"></app-pipering-bosses-grid>
                <app-pipering-bosses-managment #piperingBossManagement></app-pipering-bosses-managment>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'pipeFasteningGroups'">
            <div class="col-12">
                <app-pipe-fastening-groups-grid></app-pipe-fastening-groups-grid>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'pipeMaterialTypes'">
            <div class="col-12">
                <app-pipe-material-types-grid></app-pipe-material-types-grid>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'pipeToPiperings'">
            <div class="col-12">
                <app-pipe-to-piperings-grid #sideBar [managmentComponent]="pipeToPiperingsManagement"></app-pipe-to-piperings-grid>
                <app-pipe-to-piperings-managment #pipeToPiperingsManagement ></app-pipe-to-piperings-managment>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;" *ngIf="chooseItem === 'piperingFamilies'">
            <div class="col-12">
                <app-pipering-families-grid #sideBar [managmentComponent]="piperingFamilyManagement"></app-pipering-families-grid>
                <app-pipering-family-managment #piperingFamilyManagement ></app-pipering-family-managment>
            </div>
        </div>
    </div>
</div>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.viewerPanel{float:right;position:absolute;left:10%;padding:6px;z-index:10000000;width:80%;background:#fff}.col-sidebar{background-color:#2e2c2e;color:#fff;width:236px}.navbar{background-color:#f5f5f5;height:80px;justify-content:normal;font-size:19px;font-weight:600;text-transform:uppercase;letter-spacing:1.4px;color:#2e2c2e;padding:.5rem 2rem}.navbar .fa-angle-right{padding:0 10px 4px;font-weight:600;color:#797979}.col-navbar{padding-left:0;padding-right:0;width:calc(100% - 236px)}#viewerPanelTab{border:2px solid #989598}.information{width:360px;height:93px;background-color:#333;position:absolute;left:255px;top:15%;z-index:10}.information:after{content:"";position:absolute;width:0;height:0;border-width:10px;border-style:solid;border-color:transparent #333 transparent transparent;top:36.5px;left:-20px}.information-text{color:#fff;font-size:13px;padding:0}.information-dismiss{color:#80aa89;font-size:13px;cursor:pointer}.information-arrow{padding:0}.information-arrow2{width:0;height:0;border-top:14px solid transparent;border-right:18px solid #19af37;border-bottom:14px solid transparent;display:inline-block}.information-square{width:14px;height:15px;background:#19af37;display:inline-block}.hidden{visibility:hidden;transition:.5s;opacity:0}.displayBlock{display:-webkit-box}.menuItem{color:#797979}`]
})
export class MainPageComponent implements OnInit {
  @Input() sideBar: SideMenuComponent;
  public envName: string;
  public isStpViewerVisible = false;
  // public masterDataStateArray = [false, false, false, false, false, false];
  // public dictionariesStateArray = [false, false, false, false, false, false];
  public chooseItem:string;
  public menuTitle:string;
  public showViewerArgs: ShowViewerArgs;
  public hide: boolean;

  constructor(
    private router: Router,
    private auth: AuthService,
    private mainPageService: MainPageService
  ) { }

  public ngOnInit(): void {
    this.envName = environment.envName;
    this.mainPageService.sidemenuSubject.subscribe((value => {
      this.sidemenuChoice(value);
    }))
  };

  public logout(): void {
    this.auth.logout();
    if (this.envName === 'test') {
      this.router.navigate(['/logout']);
    }
  }

  public showViewer(event: ShowViewerArgs) {
    this.showViewerArgs = event;
    this.isStpViewerVisible = event.show;
  }

  sidemenuChoice(value: any) {
    this.chooseItem = value.choiceName;
    this.menuTitle = value.menuTitle;
    }
  }
